module.exports = __webpack_public_path__ + "img/014-toucan.04a341ee.svg";